import { render } from "./RichiestePagamento.vue?vue&type=template&id=66ac45b9&ts=true"
import script from "./RichiestePagamento.vue?vue&type=script&lang=ts"
export * from "./RichiestePagamento.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__